"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ToggleTip_1 = tslib_1.__importDefault(require("../tooltip/ToggleTip"));
/**
 * @deprecated Use {@link ToggleTip instead}, it has the same code, but the naming is more explicit
 */
class TooltipUtil {
    static attachTooltip(associatedElement, tooltipPromise, options) {
        ToggleTip_1.default.createToggleTip(associatedElement, tooltipPromise, options);
    }
}
exports.default = TooltipUtil;
//# sourceMappingURL=TooltipUtil.js.map